/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {
  private baseUrl = `${environment.endpoint}auth`;

  constructor(private httpHelperService: HttpHelperService) {}

  async getBases(data?: any): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/getBases`,
        data
      );
    } catch (error) {
      throw error;
    }
  }
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
